import { OfferPageResponse } from '@/api/generated'
import { EmptyPage } from '@/commons/models/empty-page'
import { KeyValuePair } from '@/shared/utils/key-value-pair'

export interface OffersViewModel {
  lookup: {
    categories: Array<KeyValuePair<number, string>>
    offerTypes: Array<KeyValuePair<number, string>>
  }
  offers: OfferPageResponse
}

export const EmptyOffersViewModel: OffersViewModel = {
  lookup: {
    categories: [],
    offerTypes: [],
  },
  offers: EmptyPage,
}
